module.exports = __webpack_public_path__ + "img/highSpeedRail-1.357c3247.jpg";